import React, { useState } from "react";
import api from "./api";

export default function RpaControl() {
  const [loading, setLoading] = useState(false);
  const [running, setRunning] = useState(false);

  const startRpa = async () => {
    if (loading) return;
    setLoading(true);
    try {
      const res = await api.post("/start-rpa");
      setRunning(true);
      alert(res.data.message || "RPA已启动");
    } catch (err) {
      alert(err?.response?.data?.detail || "启动失败");
    } finally {
      setLoading(false);
    }
  };

  const stopRpa = async () => {
    if (loading) return;
    setLoading(true);
    try {
      const res = await api.post("/stop-rpa");
      setRunning(false);
      alert(res.data.message || "RPA已停止");
    } catch (err) {
      alert(err?.response?.data?.detail || "停止失败");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ padding: 20 }}>
      <h2>RPA 控制面板</h2>

      <p>
        状态：
        <b style={{ color: running ? "green" : "red" }}>
          {running ? "运行中" : "已停止"}
        </b>
      </p>

      <button
        onClick={startRpa}
        disabled={loading || running}
        style={{
          padding: "10px 20px",
          marginRight: "10px",
          background: running ? "#ccc" : "#52c41a",
          color: "#fff",
          border: "none",
          cursor: "pointer",
        }}
      >
        {loading ? "启动中..." : "启动 RPA"}
      </button>

      <button
        onClick={stopRpa}
        disabled={loading || !running}
        style={{
          padding: "10px 20px",
          background: !running ? "#ccc" : "#ff4d4f",
          color: "#fff",
          border: "none",
          cursor: "pointer",
        }}
      >
        {loading ? "停止中..." : "停止 RPA"}
      </button>
    </div>
  );
}
